import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const Order = () => {
	const [searchParams] = useSearchParams();
	const intent = searchParams.get("payment_intent");
	const status = searchParams.get("redirect_status");
	const navigate = useNavigate();
	const params = useParams();

	useEffect(() => {
		const timer = setTimeout(() => {
			navigate(`/order-status/${params.rid}/${params.tid}`);
		}, 2000);
		return () => clearTimeout(timer);
	}, [navigate, params.rid, params.tid]);

	if (intent && status && status === "succeeded") {
		return (
			<div className="container-fluid">
				<div id="fda_app" className="row">
					<section id="fda_product_tile" className="col-12 hid">
						<h1 className="alert alert-primary" role="alert">
							Creating Order Please Wait!!!
						</h1>
					</section>
				</div>
			</div>
		);
	}

	return (
		<div className="container-fluid">
			<div id="fda_app" className="row">
				<section id="fda_product_tile" className="col-12 hid">
					<h1 className="alert alert-warning" role="alert">
						Please create your order.
					</h1>
				</section>
			</div>
		</div>
	);
};

export default Order;
